import React from 'react'

const Button = ({ id, onClick, text, className, icon }) => {
  return (
    <div id={id} onClick={onClick} className={className}>
      {icon && <img src={icon} />}
      <div>{text}</div>
    </div>
  )
}

export default Button